import { render, staticRenderFns } from "./TranslationTabs.vue?vue&type=template&id=3e7b0c40"
import script from "./TranslationTabs.vue?vue&type=script&lang=js"
export * from "./TranslationTabs.vue?vue&type=script&lang=js"
import style0 from "./TranslationTabs.vue?vue&type=style&index=0&id=3e7b0c40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports